/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Phone',
  definitions: {
    '16': {
      viewBox: '0 0 16 16',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.18498 1.80913C3.66877 1.32534 4.45314 1.32534 4.93692 1.80913L6.64163 3.51384C7.12542 3.99763 7.12542 4.782 6.64163 5.26578L5.81289 6.09452L9.90568 10.1873L10.7344 9.35857C11.2182 8.87479 12.0026 8.87479 12.4864 9.35857L14.1911 11.0633C14.6749 11.5471 14.6749 12.3314 14.1911 12.8152L12.9734 14.0329C12.5557 14.4506 11.9788 14.5801 11.3956 14.5497C10.8122 14.5192 10.1588 14.3281 9.48402 14.0256C8.13071 13.4189 6.58034 12.3141 5.13323 10.867C3.68611 9.41986 2.5813 7.8695 1.97464 6.51618C1.67215 5.84139 1.48102 5.18801 1.45054 4.60463C1.42006 4.02143 1.5496 3.44451 1.96733 3.02678L3.18498 1.80913ZM4.1591 2.58695C4.1049 2.53274 4.01701 2.53274 3.9628 2.58695L2.74515 3.8046C2.62488 3.92486 2.52811 4.14668 2.54904 4.54722C2.56996 4.9476 2.70798 5.46297 2.9784 6.06622C3.51757 7.26899 4.5337 8.71182 5.91104 10.0892C7.28839 11.4665 8.73122 12.4826 9.93399 13.0218C10.5372 13.2922 11.0526 13.4302 11.453 13.4512C11.8535 13.4721 12.0753 13.3753 12.1956 13.2551L13.4133 12.0374C13.4675 11.9832 13.4675 11.8953 13.4133 11.8411L11.7085 10.1364C11.6543 10.0822 11.5665 10.0822 11.5122 10.1364L10.2946 11.354C10.0798 11.5688 9.73156 11.5688 9.51677 11.354L4.64616 6.48343C4.43138 6.26864 4.43138 5.9204 4.64616 5.70562L5.86382 4.48796C5.91803 4.43375 5.91803 4.34587 5.86382 4.29166L4.1591 2.58695Z"
            fill="currentColor"
          />
        </>
      )
    },
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M5.066 3.043c.63-.63 1.651-.63 2.281 0L9.855 5.55c.63.63.63 1.651 0 2.281L8.488 9.197l6.314 6.314 1.367-1.367c.63-.63 1.651-.63 2.281 0l2.507 2.507c.63.63.63 1.651 0 2.281l-1.791 1.791c-.558.558-1.339.742-2.162.699s-1.758-.314-2.737-.753c-1.962-.879-4.221-2.487-6.336-4.602s-3.723-4.375-4.602-6.336c-.439-.979-.71-1.914-.753-2.737s.141-1.604.699-2.162l1.791-1.791zm1.433.849c-.161-.161-.423-.161-.584 0L4.124 5.682c-.233.233-.382.627-.349 1.251s.246 1.408.649 2.308c.806 1.797 2.317 3.94 4.356 5.979s4.181 3.55 5.979 4.356c.901.404 1.685.617 2.308.649s1.017-.116 1.251-.349l1.791-1.791c.161-.161.161-.423 0-.584l-2.507-2.507c-.161-.161-.423-.161-.584 0l-1.791 1.791a.6.6 0 0 1-.849 0L7.215 9.622a.6.6 0 0 1 0-.849l1.791-1.791c.161-.161.161-.423 0-.584L6.499 3.891z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
